// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";

import { Button, Spin } from "antd";
import { useApiUrl, useCustomMutation, useNotification } from "@refinedev/core";
import FileSaver from "file-saver";
import React from "react";

export const DownloadResource = ({ storageUrl = "", imoNumber = "", ukhoLicenceId = "", fileName = ""}) => {
  const [loading, setLoading] = React.useState(false);

  const apiUrl = useApiUrl();
  const { open, close } = useNotification();
  const { mutate } = useCustomMutation();



  const triggerDownload = () => {
    setLoading(true);

    try {
      FileSaver.saveAs(storageUrl, fileName)

      setLoading(false);
      open?.({
        type: "success",
        message: fileName,
        description: "File will be downloaded in a moment",
      });
      close?.("success-notification-key");

    } catch (error) {
      setLoading(false);
      open?.({
        type: "error",
        message: "Error",
        //@ts-ignore
        description: `Error: ${error.message}`,
      });
      close?.("error-notification-key");
    }
  }

  return loading ? (
    <Spin></Spin>
  ) : (
    <div>
      <Button
        type="link"
        size="small"
        onClick={triggerDownload}
        target="_blank"
        icon={<Icons.DownloadOutlined />}
      ></Button>
    </div>
  );  
};